<template>
  <div>
    <!-- Main section start -->
    <main-section v-bind="$attrs"></main-section>
    <!-- Main section end -->

    <!-- About section start -->
    <about-section ref="aboutSection"></about-section>
    <!-- About section end -->

    <!-- Other sections... -->
  </div>
</template>

<script>
import MainSection from '@/sections/MainSection.vue';
import AboutSection from '@/sections/AboutSection.vue';

export default {
  components: {
    MainSection,
    AboutSection,
  },
  mounted() {
    // Handle scrolling with a delay to ensure elements are properly rendered
    this.handleScrollToSection();
  },
  methods: {
    handleScrollToSection() {
      if (this.$route.query.scrollTo === 'about') {
        // Use a significant delay to ensure everything is rendered
        setTimeout(() => {
          this.scrollToAboutSection();
        }, 1000);
      }
    },
    
    scrollToAboutSection() {
      // Try multiple ways to find the section
      const aboutSection = 
        document.getElementById('about-section') || 
        this.$refs.aboutSection?.$el;
      
      if (!aboutSection) {
        console.error('About section not found');
        return;
      }
      
      try {
        // Method 1: scrollIntoView
        aboutSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
		this.$router.replace({ path: '/' }, () => {}, () => {});
      } catch (error) {
        console.error('Error scrolling:', error);
      }
    }
  }
}
</script>